import { render } from "./RaceEventResults.vue?vue&type=template&id=06ebf876&scoped=true"
import script from "./RaceEventResults.vue?vue&type=script&lang=js"
export * from "./RaceEventResults.vue?vue&type=script&lang=js"

import "./RaceEventResults.vue?vue&type=style&index=0&id=06ebf876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ebf876"]])

export default __exports__